marquee(".hero__testimonials")

function marquee(selector) {
    const marqueeElement = document.querySelector(selector)

    if (!marqueeElement) return
    
    const repeatingElement = marqueeElement.firstElementChild
    const clone = repeatingElement.cloneNode(true)

    clone.ariaHidden = true

    marqueeElement.append(clone)
}
